export default "<div class=\"kt-portlet\" [ngClass]=\"class\" #portlet>\r\n\t<ng-content></ng-content>\r\n</div>\r\n"